export default __webpack_public_path__ + "static/media/adminPrompt.b816c4b8.svg";